import { render, staticRenderFns } from "./LayoutV1.vue?vue&type=template&id=482f372b&scoped=true&"
import script from "./LayoutV1.vue?vue&type=script&lang=js&"
export * from "./LayoutV1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "482f372b",
  null
  
)

export default component.exports